<template>
    <div class="modal fade" tabindex="-1" :id="id">
        <div class="modal-dialog modal-lg">
          <form id="kt_modal_form_project" @submit.prevent="updateProject" class="form mt-5" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('tasks.addUsers') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor"/>
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor"/>
                    </svg>
                  </span>
                </div>
              </div>
              <div class="modal-body">
                <Select2
                    :parent-id="'#'+id"
                    :is-required="true"
                    container-class="col-12 mb-5"
                    :multiple="true"
                    :show-search="true"
                    :name="`${id}-task-users`"
                    :label="$t('tasks.label.users')"
                    label-class="form-label"
                    v-model="formData.users"
                >
                    <option v-for="user in users" :value="user?.id" :key="user?.id">
                      {{ user.fullname ?? user.firstname + ' '+ user?.lastname}}
                    </option>
                </Select2>
              </div>
              <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>
</template>

<script setup>

import { defineProps,onMounted,ref, watch } from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import { computed } from 'vue';
import Select2 from '@/components/Select2.vue';

const props = defineProps({
  formEdit:{
      type:Object,
      default:{}
  },
  id:{type: String, default:"add_task_users"} ,
  users:{type: Array, default:[]} 

})

const store = useStore()

const formData = ref(props.formEdit)

watch(() => props.formEdit, (value) => {
    formData.value = props.formEdit
}, { deep: true })

const isLoading = ref(false)

const emit = defineEmits(['load'])

function closeModal(){
  $('#'+props.id).modal('toggle')
}

async function updateProject() {
    isLoading.value = true
    try{
      await store.dispatch('tasks/updateTaskAssignUser', formData.value)
      window.toastr.success(i18n.global.t("notification.task_updated"))
      emit('load')
      formData.value={
        task_id: "",
        users: []
      }
      isLoading.value = false
      $('#'+props.id).modal('toggle')
    }catch(err){
      isLoading.value = false
    }
}




</script>
